import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export default function SettingsAdminPage() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/settings").then((r) => setS(r.data)); }, []);
  const save = async () => { try { await api.patch("/settings", s); toast.success("Saved"); } catch (e) { toast.error(formatApiError(e)); } };
  const F = (label, k, type = "text") => (<div><label className="text-xs font-semibold text-gray-600">{label}</label><input type={type} value={s[k] || ""} onChange={(e) => setS({ ...s, [k]: e.target.value })} className="mt-1 w-full rounded-md border border-gray-200 px-3 py-2 text-sm" /></div>);
  return (
    <div className="space-y-5" data-testid="admin-settings-page">
      <h1 className="font-display font-extrabold text-2xl text-gray-900">Business Settings</h1>
      <div className="bg-white rounded-xl border border-gray-200 p-6 space-y-6 max-w-4xl">
        <Section title="Contact Information">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {F("Phone (shown everywhere)", "phone")}
            {F("WhatsApp (international format, e.g. +919…)", "whatsapp_number")}
            {F("Email", "email")}
            {F("Business Hours", "business_hours")}
            <div className="md:col-span-2">{F("Address", "address")}</div>
            <div className="md:col-span-2"><label className="text-xs font-semibold text-gray-600">Google Maps embed URL</label>
              <input value={s.map_embed || ""} onChange={(e) => setS({ ...s, map_embed: e.target.value })} className="mt-1 w-full rounded-md border border-gray-200 px-3 py-2 text-sm" /></div>
          </div>
        </Section>
        <Section title="Social Links">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {F("Instagram URL", "instagram")}
            {F("Instagram Handle (without @)", "instagram_handle")}
            {F("Facebook URL", "facebook")}
            {F("YouTube URL", "youtube")}
          </div>
        </Section>
        <div><button onClick={save} className="btn-primary"><Save size={14} /> Save Settings</button></div>
      </div>
    </div>
  );
}
const Section = ({ title, children }) => (<div className="pb-6 border-b border-gray-100 last:border-0"><h2 className="font-display font-bold text-sm text-gray-900 mb-3">{title}</h2>{children}</div>);
